import { useEffect, useState, useCallback } from "react";
import useErroPadrao from "../../../hooks/useErroPadrao";
import useHelp from "../../../hooks/useHelp";
import { useNavigate } from "react-router-dom";
import { CHAVE_TOKEN, real, dataBR, hojeISO } from "../../../utils/formata";
import PagarEmDiarias from "./PagarEmDiarias";

const categorias = {
    despesa: "Despesa geral",
    aluguel: "Aluguel",
    salarios: "Salários / Comissões",
    combustivel: "Combustível / Transporte",
    alimentacao: "Alimentação",
    material: "Material / Equipamento",
    marketing: "Marketing / Anúncios",
    impostos: "Impostos / Taxas",
    outro: "Outro",
};
const iconesCat = {
    despesa: "bi-receipt", aluguel: "bi-house-door", salarios: "bi-people",
    combustivel: "bi-fuel-pump", alimentacao: "bi-cup-hot", material: "bi-box-seam",
    marketing: "bi-megaphone", impostos: "bi-bank", outro: "bi-three-dots",
};
const ordem = Object.keys(categorias);
const mesAtual = () => hojeISO().slice(0, 7);

export default function DespesasPainel() {
    const [mes, setMes] = useState(mesAtual());
    const [dados, setDados] = useState({ total: 0, porCategoria: {}, despesas: [], fixas: [] });
    const [carregando, setCarregando] = useState(true);
    const [novo, setNovo] = useState({ categoria: "despesa", data: hojeISO(), formaPagamento: "pix", fixarMensal: false });
    const [lancando, setLancando] = useState(false);
    const { listarDespesas, adicionarDespesa, removerDespesa, lancarDespesasFixas, removerDespesaFixa } = useHelp();
    const { setErroPadrao } = useErroPadrao();
    const navigate = useNavigate();

    const carregar = useCallback(() => {
        setCarregando(true);
        listarDespesas(mes)
            .then((data) => setDados(data))
            .catch((error) => setErroPadrao(error))
            .finally(() => setCarregando(false));
    }, [mes, listarDespesas, setErroPadrao]);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) { navigate("/login"); return; }
        carregar();
    }, [carregar, navigate]);

    function handleLancar(e) {
        e.preventDefault();
        setLancando(true);
        adicionarDespesa(novo)
            .then(() => { setNovo({ categoria: "despesa", data: hojeISO(), formaPagamento: "pix", fixarMensal: false }); carregar(); })
            .catch((error) => setErroPadrao(error))
            .finally(() => setLancando(false));
    }

    function handleExcluir(id) {
        if (!window.confirm("Excluir essa despesa? Ela sai do caixa também.")) return;
        removerDespesa(id).then(carregar).catch((error) => setErroPadrao(error));
    }

    function handleLancarFixas() {
        lancarDespesasFixas(mes).then(carregar).catch((error) => setErroPadrao(error));
    }

    function handleExcluirFixa(id) {
        if (!window.confirm("Remover essa despesa fixa? (não apaga as já lançadas)")) return;
        removerDespesaFixa(id).then(carregar).catch((error) => setErroPadrao(error));
    }

    const maiorCat = Math.max(...Object.values(dados.porCategoria || {}), 1);
    const cats = ordem.filter((c) => dados.porCategoria?.[c]);

    return (
        <div className="pagina">
            <h2 className="he-titulo">Despesas <span className="he-dourado">— Gastos do negócio</span></h2>
            <p style={{ color: "#9aa5b5", marginTop: -6, fontSize: "0.9em" }}>
                Tudo que você lança aqui já entra no <strong>Caixa</strong>, no <strong>Dashboard</strong> e na <strong>Contabilidade</strong>.
            </p>

            {/* Mês + total */}
            <div style={{ display: "flex", gap: "1em", flexWrap: "wrap", alignItems: "flex-end", margin: "1em 0" }}>
                <div className="campo-form" style={{ maxWidth: 200 }}>
                    <label className="form-label he-dourado" style={{ fontSize: "0.8em" }}>Mês</label>
                    <input className="form-control" type="month" value={mes} onChange={(e) => setMes(e.target.value)} />
                </div>
                <div className="card-estat card-heroi" style={{ flex: "1 1 240px" }}>
                    <div className="estat-rotulo">▼ TOTAL DE DESPESAS DO MÊS</div>
                    <div className="estat-numero" style={{ color: "#ff6b5b" }}>{real(dados.total)}</div>
                </div>
            </div>

            <PagarEmDiarias onMudou={carregar} />

            {/* Quebra por categoria */}
            {cats.length > 0 &&
                <div className="he-card" style={{ marginBottom: "1em" }}>
                    <h6 className="he-titulo he-dourado"><i className="bi bi-pie-chart"></i> Por categoria</h6>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                        {cats.sort((a, b) => dados.porCategoria[b] - dados.porCategoria[a]).map((c) => (
                            <div key={c}>
                                <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85em", marginBottom: 3 }}>
                                    <span><i className={`bi ${iconesCat[c]}`} style={{ marginRight: 6, color: "#d4af37" }}></i>{categorias[c]}</span>
                                    <strong style={{ color: "#ff6b5b" }}>{real(dados.porCategoria[c])}</strong>
                                </div>
                                <div style={{ height: 6, background: "#0f1e2e", borderRadius: 4, overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${(dados.porCategoria[c] / maiorCat) * 100}%`, background: "linear-gradient(90deg,#ff6b5b,#d4af37)" }}></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }

            {/* Nova despesa */}
            <form onSubmit={handleLancar} className="he-card form-mobile" style={{ marginBottom: "1em" }}>
                <h6 className="he-titulo he-dourado"><i className="bi bi-plus-circle"></i> Nova despesa</h6>
                <div className="row">
                    <div className="col-md-3 campo-form" style={{ marginBottom: 8 }}>
                        <label className="form-label" style={{ fontSize: "0.8em" }}>Categoria</label>
                        <select className="form-select form-select-sm" value={novo.categoria} onChange={(e) => setNovo({ ...novo, categoria: e.target.value })}>
                            {ordem.map((c) => <option key={c} value={c}>{categorias[c]}</option>)}
                        </select>
                    </div>
                    <div className="col-md-2 campo-form" style={{ marginBottom: 8 }}>
                        <label className="form-label" style={{ fontSize: "0.8em" }}>Valor</label>
                        <input className="form-control form-control-sm" type="number" step="0.01" min="0.01" inputMode="decimal" placeholder="0,00" value={novo.valor || ""} onChange={(e) => setNovo({ ...novo, valor: e.target.value })} required />
                    </div>
                    <div className="col-md-2 campo-form" style={{ marginBottom: 8 }}>
                        <label className="form-label" style={{ fontSize: "0.8em" }}>Data</label>
                        <input className="form-control form-control-sm" type="date" value={novo.data} onChange={(e) => setNovo({ ...novo, data: e.target.value })} required />
                    </div>
                    <div className="col-md-2 campo-form" style={{ marginBottom: 8 }}>
                        <label className="form-label" style={{ fontSize: "0.8em" }}>Forma</label>
                        <select className="form-select form-select-sm" value={novo.formaPagamento} onChange={(e) => setNovo({ ...novo, formaPagamento: e.target.value })}>
                            <option value="pix">PIX</option>
                            <option value="dinheiro">Dinheiro</option>
                            <option value="transferencia">Transferência</option>
                            <option value="boleto">Boleto</option>
                            <option value="cartao">Cartão</option>
                        </select>
                    </div>
                    <div className="col-md-3 campo-form" style={{ marginBottom: 8 }}>
                        <label className="form-label" style={{ fontSize: "0.8em" }}>Descrição</label>
                        <input className="form-control form-control-sm" placeholder="Ex: aluguel da sala" value={novo.descricao || ""} onChange={(e) => setNovo({ ...novo, descricao: e.target.value })} />
                    </div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.85em", cursor: "pointer" }}>
                        <input type="checkbox" checked={novo.fixarMensal} onChange={(e) => setNovo({ ...novo, fixarMensal: e.target.checked })} />
                        <span><i className="bi bi-arrow-repeat" style={{ color: "#d4af37" }}></i> É uma despesa fixa (repete todo mês)</span>
                    </label>
                    <button type="submit" className="btn btn-sm btn-he" disabled={lancando}>
                        {lancando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-check-lg"></i> Lançar despesa</>}
                    </button>
                </div>
            </form>

            {/* Despesas fixas */}
            {dados.fixas.length > 0 &&
                <div className="he-card" style={{ marginBottom: "1em", borderColor: "rgba(212,175,55,0.4)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                        <h6 className="he-titulo he-dourado" style={{ margin: 0 }}><i className="bi bi-arrow-repeat"></i> Despesas fixas mensais</h6>
                        <button className="btn btn-sm btn-outline-he" onClick={handleLancarFixas}>
                            <i className="bi bi-calendar-plus"></i> Lançar as fixas neste mês
                        </button>
                    </div>
                    <div className="acoes-linha" style={{ flexWrap: "wrap", gap: 8, marginTop: 10 }}>
                        {dados.fixas.map((f) => (
                            <span key={f.id} className="chip-fixa">
                                <i className={`bi ${iconesCat[f.categoria] || "bi-receipt"}`}></i> {f.descricao} · {real(f.valor)}{f.diaVencimento ? ` · dia ${f.diaVencimento}` : ""}
                                <button className="chip-x" title="Remover fixa" onClick={() => handleExcluirFixa(f.id)}>×</button>
                            </span>
                        ))}
                    </div>
                </div>
            }

            {/* Lista */}
            {carregando ? <div style={{ textAlign: "center", padding: "2em" }}><span className="spinner-border" style={{ color: "#d4af37" }}></span></div> :
                <div className="he-card sem-rolagem">
                    <div className="tabela-rolavel rolagem-so-desktop">
                    <table className="table table-striped table-hover tabela-responsiva" style={{ fontSize: "0.9em" }}>
                        <thead>
                            <tr><th></th><th>Data</th><th>Categoria</th><th>Descrição</th><th>Forma</th><th>Valor</th><th></th></tr>
                        </thead>
                        <tbody>
                            {dados.despesas.map((m) => (
                                <tr key={m.id}>
                                    <td className="esconder-mobile"><i className={`bi ${iconesCat[m.categoria] || "bi-receipt"}`} style={{ color: "#d4af37" }}></i></td>
                                    <td data-rotulo="Data">{dataBR(m.data)}</td>
                                    <td className="principal ordem-primeiro" data-rotulo="Categoria">{categorias[m.categoria] || m.categoria}</td>
                                    <td data-rotulo="Descrição">{m.descricao || "—"}</td>
                                    <td data-rotulo="Forma">{m.formaPagamento || "—"}</td>
                                    <td className="destaque" data-rotulo="Valor" style={{ fontWeight: 700, color: "#ff6b5b" }}>-{real(m.valor)}</td>
                                    <td className="acoes">
                                        <div className="acoes-linha uma-coluna">
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleExcluir(m.id)}><i className="bi bi-trash"></i> <span className="so-mobile-inline">Excluir</span></button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {dados.despesas.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "#9aa5b5", padding: "1.5em" }}>Nenhuma despesa neste mês. Lance a primeira acima 👆</td></tr>}
                        </tbody>
                    </table>
                    </div>
                </div>}
        </div>
    );
}
